import ImportCsv from "@/features/import-csv";
import type { ExportApiUrl } from "@/features/import-csv/types";
import { ImportCsvSearchSchema } from "@/features/import-csv/zod-schemas";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import usePlaceTableRows from "./-hooks/usePlaceTableRows";

const PlaceImportCsv = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.places.importCsv",
  });

  const { t: tCompleteDialog } = useTranslation(defaultNS, {
    keyPrefix: "pages.places.importCsv.completeDialog",
  });

  const title = t("title");
  const exportApiUrl: ExportApiUrl = "/v2/places-csv";
  const exportFilename = t("exportFilename");
  const unit = t("unit");

  const templateMessage = {
    templateTitle: t("prepareCsvFile.templateTitle"),
    updateExisting: t("prepareCsvFile.updateExisting"),
    completeLinkButton: tCompleteDialog("button"),
  };

  return (
    <ImportCsv
      baseLink="/places/import-csv"
      baseTitle={title}
      exportApiUrl={exportApiUrl}
      exportFilename={exportFilename}
      templateMessage={templateMessage}
      completeLinkUrl="/places"
      unit={unit}
      search={search}
      navigate={navigate}
      useTableRows={usePlaceTableRows}
    />
  );
};

export const Route = createFileRoute("/_staff/places/import-csv")({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  component: PlaceImportCsv,
});
